import React, { useEffect } from 'react';
import * as redux from '../../redux';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router';

import { STORAGE_KEY as AT_HOME_CODE_STORAGE_KEY } from 'screens/Results/AtHomeTesting/RegisterCustomCode/hooks/useRegisterHomeTesting';

const logout = redux.patient.logout;

const Logout = (props: { history: any }) => {
  const dispatch = useDispatch();
  const { history } = props;

  useEffect(() => {
    dispatch(logout());
    sessionStorage.removeItem(AT_HOME_CODE_STORAGE_KEY);
  }, [dispatch, history]);
  return <Redirect to="/login" />;
};

export default Logout;
